import Remove from "../../icons/remove.inline.svg";
import SvgIcon from "./SvgIcon";

export default SvgIcon(Remove);
